// extracted by mini-css-extract-plugin
export var fadeIn = "_kj-1";
export var modalContent = "_kj-3";
export var overlay = "_kj-0";
export var popoverContent = "_kj-2";
export var results = "_kj-5";
export var searchInputWrapper = "_kj-4";